<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-row dense>
                        <v-col cols="12">
                            <ModalInformacionComponent :titulo="obModal.titulo" :open="obModal.open" :descripcion="obModal.descripcion"/>
                        </v-col>
                    </v-row>
                    
                    <v-row dense align="center" justify="center">
                        <v-col cols="12" class="text-center">
                            <h3 class="title" style="color: #EE4637">Datos de la facturación</h3><br />
                            <h5 class="subtitle-1" style="color: #EE4637">¿A nombre de quién deseas tu factura?</h5>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="1" md="3"/>
                        <v-col cols="12" sm="10" md="6">
                            <v-radio-group v-model="radioGroup" row dense class="text-center">
                                <v-radio color="primary" v-for="(v,k) in listSeleccionFactura" :key="k" :label="v.text" :value="v.value" />
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" sm="1" md="3"/>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="1" md="2"/>
                        <v-col cols="12" sm="10" md="8">
                            <v-form ref="form_factura" :lazy-validation="true">
                                <!-- Mis Datos -->
                                <v-row dense v-if="radioGroup == 1">
                                    <v-col cols="12" sm="12">
                                        <v-row dense>
                                            <v-col cols="12" sm="6">
                                                <v-text-field label="CÉDULA" color="textbox"
                                                    v-model="objDatosFactura.numeroDocumento" disabled outlined dense />
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-autocomplete label="CIUDAD *" color="textbox"
                                                    v-model="objDatosFactura.idCanton" item-text="canton" item-value="idCanton"
                                                    :items="listGeneral.listaCantones" :rules="requeridoRegla" outlined dense />
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col cols="12" sm="12">
                                                <v-text-field label="NOMBRES" color="textbox"
                                                    v-model="objDatosFactura.nombreCliente" disabled outlined dense />
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col cols="12" sm="12">
                                                <v-text-field label="DIRECCIÓN" color="textbox"
                                                    v-model="objDatosFactura.direccion" disabled outlined dense />
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col cols="12" sm="6">
                                                <v-text-field label="TELÉFONO" color="textbox"
                                                    v-model="objDatosFactura.telefono" :mask="'(###) ### - ####'" disabled
                                                    outlined dense />
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-text-field label="E-MAIL" color="textbox" v-model="objDatosFactura.email"
                                                    disabled outlined dense />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <!-- Otra Persona -->
                                <v-row dense v-else-if="radioGroup == 2">
                                    <v-col cols="12" sm="12">
                                        <v-row dense>
                                            <v-col cols="12" sm="6">
                                                <v-text-field label="CÉDULA" color="textbox"
                                                    v-model="objDatosFactura.numeroDocumento"
                                                    :rules="_.concat(requeridoRegla,cedula)" outlined dense />
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-autocomplete label="CIUDAD *" color="textbox"
                                                    v-model="objDatosFactura.idCanton" item-text="canton" item-value="idCanton"
                                                    :items="listGeneral.listaCantones" :rules="requeridoRegla" outlined dense />
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col cols="12" sm="12">
                                                <v-text-field label="NOMBRES" color="textbox"
                                                    v-model="objDatosFactura.nombreCliente"
                                                    :rules="_.concat(requeridoRegla,soloLetrasRegla(1,objDatosFactura.nombreCliente,300))"
                                                    outlined dense />
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col cols="12" sm="12">
                                                <v-text-field label="DIRECCIÓN" color="textbox"
                                                    v-model="objDatosFactura.direccion" :rules="_.concat(requeridoRegla)"
                                                    outlined dense />
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col cols="12" sm="6">
                                                <v-text-field label="TELÉFONO" color="textbox"
                                                    v-model="objDatosFactura.telefono" :mask="'(###) ### - ####'"
                                                    :rules="_.concat(requeridoRegla,[v => _.size(objDatosFactura.telefono) > 8 || 'El número de teléfono debe tener mínimo 9 dígitos'])"
                                                    outlined dense />
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-text-field label="E-MAIL" color="textbox" v-model="objDatosFactura.email"
                                                    :rules="_.concat(requeridoRegla,emailRegla)" outlined dense />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <!-- Empresa -->
                                <v-row dense v-else-if="radioGroup == 3">
                                    <v-col cols="12" sm="12">
                                        <v-row dense>
                                            <v-col cols="12" sm="6">
                                                <v-text-field label="RUC" color="textbox"
                                                    v-model="objDatosFactura.numeroDocumento"
                                                    :rules="_.concat(requeridoRegla,ruc)" outlined dense />
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-autocomplete label="CIUDAD *" color="textbox"
                                                    v-model="objDatosFactura.idCanton" item-text="canton" item-value="idCanton"
                                                    :items="listGeneral.listaCantones" :rules="requeridoRegla" outlined dense />
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col cols="12" sm="12">
                                                <v-text-field label="RAZÓN SOCIAL" color="textbox"
                                                    v-model="objDatosFactura.razon_social"
                                                    :rules="_.concat(requeridoRegla,soloLetrasRegla(1,objDatosFactura.nombreCliente,300))"
                                                    disabled outlined dense />
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col cols="12" sm="12">
                                                <v-text-field label="DIRECCIÓN" color="textbox"
                                                    v-model="objDatosFactura.direccion" :rules="_.concat(requeridoRegla)"
                                                    outlined dense />
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col cols="12" sm="6">
                                                <v-text-field label="TELÉFONO" color="textbox"
                                                    v-model="objDatosFactura.telefono" :mask="'(###) ### - ####'"
                                                    :rules="_.concat(requeridoRegla,[v => _.size(objDatosFactura.telefono) > 8 || 'El número de teléfono debe tener mínimo 9 dígitos'])"
                                                    outlined dense />
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-text-field label="E-MAIL" color="textbox" v-model="objDatosFactura.email"
                                                    :rules="_.concat(requeridoRegla,emailRegla)" outlined dense />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="1" sm="1">
                                        <v-checkbox color="primary" v-model="checkAceptacion" dense />
                                    </v-col>
                                    <v-col cols="11" sm="11">
                                        <p style="color: #000;margin-top: 21px;margin-bottom: 21px;">
                                            Declaro que he leído y aceptado los <a id="termino" style="color:#EE4637" @click="verDetalle"> Términos y
                                                Condiciones.</a>
                                        </p>
                                    </v-col>
                                </v-row>
                                <v-row dense class="mt-3 mb-3" align="center" justify="center">
                                    <v-col cols="12" class="text-right">
                                        <v-btn rounded color="primary" @click="validar" dark>
                                            <!-- <v-icon color="secundary">save_alt</v-icon> -->
                                            <span class="ml-1">Renovar</span>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-col>
                        <v-col cols="12" sm="1" md="2"/>
                    </v-row>

                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowDatosFacturaComponent',
        inject: ['updateData','onBotonPago'],
        props:{
            listGeneral:{
                type:Object,
                default:{}
            },
            objFormFactura:{
                type:Object,
                default:{}
            },
            parametros:{
                type:Object,
                default:{}
            },
            stepper:{
                type:Number
            },
            textoTerminoCondicionVenta:{
                type:String,
                default:''
            }
            
        },
        components:{
            ModalInformacionComponent: () => import('./ModalInformacionComponent.vue')
        },
        data(){
            return{
                listSeleccionFactura:[
                    {value: 1, text: 'MIS DATOS'},
                    {value: 2, text: 'OTRA PERSONA'},
                    {value: 3, text: 'EMPRESA'}
                ],
                radioGroup: 1,
                objDatosFactura:{},
                checkAceptacion: false,
                obModal:{
                    titulo:'',
                    open:false,
                    descripcion:''
                },
            }
        },
        created(){
            this.setData();
        },
        watch:{
            stepper(val){
                this.objDatosFactura = {};
                if(val == 6){
                    this.setData();
                }
            },
            radioGroup(){
                this.$refs.form_factura.resetValidation();
                switch (this.radioGroup) {
                    case 2:
                        this.objDatosFactura = {};
                        this.objDatosFactura.idTipoPersona = this.parametros.id_tipo_persona_natural;
                        this.objDatosFactura.idTipoDocumento = this.parametros.id_tipo_doc_cedula;
                        break;
                    case 3:
                        this.objDatosFactura = {};
                        this.objDatosFactura.idTipoPersona = this.parametros.id_tipo_persona_juridica;
                        this.objDatosFactura.idTipoDocumento = this.parametros.id_tipo_doc_ruc;
                        break;
                    default:
                        this.objDatosFactura = _.clone(this.objFormFactura);
                        this.objDatosFactura.idTipoPersona = this.parametros.id_tipo_persona_natural;
                        this.objDatosFactura.numeroDocumento = this.objDatosFactura.nroDocumento;
                        this.objDatosFactura.nombreCliente = this.objDatosFactura.cliente;
                        break;
                }
            }
        },
        methods:{
            setData(){
                this.$set(this,'objDatosFactura', _.clone(this.objFormFactura));
                this.$set(this.objDatosFactura,'idTipoPersona',this.parametros.id_tipo_persona_natural);
                this.$set(this.objDatosFactura,'numeroDocumento',this.objDatosFactura.nroDocumento);
                this.$set(this.objDatosFactura,'nombreCliente',this.objDatosFactura.cliente);
            },
            verDetalle(){
                this.obModal = {
                    titulo: 'Términos y Condiciones de Uso de Sitio Web',
                    descripcion: this.textoTerminoCondicionVenta,
                    open: true
                };
            },
            close(){
                this.obModal = {
                    titulo:'Términos y Condiciones de Uso de Sitio Web',
                    open: false,
                    descripcion:this.textoTerminoCondicionVenta
                };
            },
            validar(){
                try {
                    if(!this.$refs.form_factura.validate()) throw mensajeEstandar.corregirInformacion;
                    if(!this.checkAceptacion) throw 'Debe aceptar los términos y condiciones.';
                        this.updateData('objForm.objFormFactura',this.objDatosFactura);
                        this.onBotonPago();
                    return true;
                } catch (error) {
                    mensajesAlerta(error,'E');
                    return false;
                }
            }
        },
        provide(){
            return{
                close: this.close
            }
        }
    }
</script>

<style>
    #termino:hover{
        text-decoration: underline;
    }
    #termino:active {
    text-decoration: underline;
    }
</style>